import { FC } from 'react';

export const DocumentMultiple: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.71429 4C9.22615 4 9 4.33794 9 4.55556V15.4444C9 15.6621 9.22615 16 9.71429 16H18.2857C18.7738 16 19 15.6621 19 15.4444V8.41421L14.5858 4H9.71429ZM7 4.55556C7 3.05495 8.30887 2 9.71429 2H14.5858C15.1162 2 15.6249 2.21071 16 2.58579L20.4142 7C20.7893 7.37507 21 7.88378 21 8.41421V15.4444C21 16.945 19.6911 18 18.2857 18H17V19C17 20.6569 15.6569 22 14 22H6C4.34315 22 3 20.6569 3 19V9C3 7.34315 4.34315 6 6 6H7V4.55556ZM7 8H6C5.44772 8 5 8.44772 5 9V19C5 19.5523 5.44772 20 6 20H14C14.5523 20 15 19.5523 15 19V18H9.71429C8.30887 18 7 16.945 7 15.4444V8Z"
			fill="currentColor"
		/>
	</svg>
);
